export class TherapistGroupAppointmentInfo {
  appUserInfoId: string;
  modifiedByUserInfoId: number;
  enableGroupSession: boolean;
  patientCount: number;
}

export interface TherapistGroupAppointmentDto {
  id: number;
  therapistId: number;
  patientCount: number;
  createdBy: string;
  createdOn: string; 
  enableGroupSession:boolean;
}